var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';
import { getAdresseByGoogle, getAdressesByGoogle } from '../services/utils';
import { LocationIcon } from './Icons';
import { isError } from '../components/error/Error';
var intervalId;
export var InputAutoCompleteAdresse = function (_a) {
    var onChange = _a.onChange;
    var _b = useState(null), value = _b[0], setValue = _b[1];
    var _c = useState(''), inputValue = _c[0], setInputValue = _c[1];
    var _d = useState([]), options = _d[0], setOptions = _d[1];
    var _e = useState(false), loading = _e[0], setLoading = _e[1];
    var _f = useState(false), loadingOptions = _f[0], setLoadingOptions = _f[1];
    var getOptions = function (search) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (search === inputValue || search.length === 0) {
                return [2 /*return*/];
            }
            setInputValue(search);
            setLoadingOptions(true);
            if (intervalId) {
                clearInterval(intervalId);
            }
            intervalId = setInterval(function (search) { return __awaiter(void 0, void 0, void 0, function () {
                var newSuggestions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            clearInterval(intervalId);
                            return [4 /*yield*/, getAdressesByGoogle(search, true)];
                        case 1:
                            newSuggestions = _a.sent();
                            if (!isError(newSuggestions)) {
                                setOptions(newSuggestions);
                            }
                            setLoadingOptions(false);
                            return [2 /*return*/];
                    }
                });
            }); }, 1000, search);
            return [2 /*return*/];
        });
    }); };
    return (_jsx(Autocomplete, { loading: loadingOptions, loadingText: "Recherche en cours...", fullWidth: true, getOptionLabel: function (option) {
            return typeof option === 'string' ? option : option.label;
        }, filterOptions: function (x) { return x; }, options: options, autoComplete: true, includeInputInList: true, filterSelectedOptions: true, value: value, noOptionsText: "Aucune adresse", isOptionEqualToValue: function () { return true; }, onChange: function (event, newValue) { return __awaiter(void 0, void 0, void 0, function () {
            var adresseInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!newValue) {
                            setValue(null);
                            return [2 /*return*/];
                        }
                        setLoading(true);
                        setValue(newValue.value);
                        return [4 /*yield*/, getAdresseByGoogle(newValue.value)];
                    case 1:
                        adresseInfo = _a.sent();
                        onChange(adresseInfo);
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); }, onInputChange: function (event, newInputValue) {
            getOptions(newInputValue);
        }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { InputProps: __assign(__assign({}, params.InputProps), { startAdornment: _jsx(LocationIcon, { color: "primary" }) }), label: "Rechercher une adresse", fullWidth: true }))); }, renderOption: function (props, option) {
            return (_jsx("li", __assign({}, props, { children: _jsxs(Grid, __assign({ container: true, alignItems: "center" }, { children: [_jsx(Grid, __assign({ item: true, sx: { display: 'flex', width: 44 } }, { children: _jsx(LocationIcon, { sx: { color: 'text.secondary' } }) })), _jsx(Grid, __assign({ item: true, sx: { width: 'calc(100% - 44px)', wordWrap: 'break-word' } }, { children: _jsx("div", { dangerouslySetInnerHTML: { __html: option.label } }) }))] })) })));
        } }, loading ? 'searchAdresseLoading' : 'searchAdresse'));
};
//# sourceMappingURL=InputAutoCompleteAdresse.js.map